import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@gemini/ui";
import { useConfig } from "@/contexts/cdpConfig";
import { useI18n } from "@/shared/hooks";
export const ShareCTA = ({ dark, showBorder = false, icon, onPress, }) => {
    const { t } = useI18n();
    const inverted = dark ? "-inverted" : "";
    const isPreviewMode = useConfig().previewMode;
    return (_jsx(Button, { onPress: onPress, icon: icon, iconOnly: true, variant: showBorder ? `secondary${inverted}` : `tertiary${inverted}`, size: "40", isDisabled: isPreviewMode, children: t("common.CTA.share.label") }));
};
